const NS = 'CarouselBlock';
const CLS = 'carouselBlock';

import { mediaQuery } from '../../../../global/js/wlc/mediaQuery';
import { fullWindowHeightMixinBlock } from '../../mixins/fullWindowHeightMixinBlock/fullWindowHeightMixinBlock';
import { trackingScrollMixinBlock } from '../../mixins/trackingScrollMixinBlock/trackingScrollMixinBlock';

export class CarouselBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.mediaQuery = mediaQuery;
		this.layouts = {
			Default: '',
			FullContainerWidth: 'fullContainerWidth',
			FullScreen: 'fullScreen'
		};
		this.selectedLayout = this.layouts.Default;

		this.$elementInner = this.$element.find(`.${CLS}-inner`);
		this.$sliderContainer = this.$element.find(`.${CLS}-sliderContainer`);
		this.$carouselItems = this.$element.find(`.${CLS}-item`);
		this.$carouselSlider = this.$element.find(`.${CLS}-slider`);
		this.$carouselSlider.slick({
			dots: true,
			dotsClass: `slick-dots`,
			appendArrows: this.$sliderContainer,
			appendDots: this.$sliderContainer,
			nextArrow: `<button type="button" class="slick-arrow slick-arrow--next"><i class="slick-arrow-icon icon icon--chevron-right"></i></button>`,
			prevArrow: `<button type="button" class="slick-arrow slick-arrow--previous"><i class="slick-arrow-icon icon icon--chevron-left"></i></button>`,
			infinite: false,
			cssEase: 'ease-in-out',
			useTransform: true
		});

		this.carouselArrowButton = this.$element.find(`.slick-arrow`);

		// Set the particular layout
		this.setSelectedLayout();

		// Set the positioning of the carousel elements
		this.adjustCarouselItems();

		// Display the carousel
		this.$carouselItems.css({ visibility: 'visible' });

		$(window).resize(_.debounce(() => {
			this.adjustCarouselItems();
		}, 50, { trailing: true }));

		this.initFullWindowHeight(this);
		this.initTrackingScroll(this);
	}

	setSelectedLayout() {
		let selectedLayout = this.$element.data('layout');
		let isFound = _.find(this.layouts, (layout) => {
			return layout === selectedLayout;
		});

		if(isFound) {
			this.selectedLayout = selectedLayout;

			if(this.selectedLayout === this.layouts.FullContainerWidth) {
				this.$element.addClass(`${CLS}--fullContainerWidth`);
			}
			else if(this.selectedLayout === this.layouts.FullScreen) {
				this.$element.addClass(`${CLS}--fullScreen`);
			}
		}
	}

	adjustCarouselItems() {
		this.adjustArrowVisibility();
		this.assignImageRatio();
		this.adjustArrowPosition();
	}

	assignImageRatio() {
		if(this.selectedLayout === this.layouts.FullScreen) {
			let height;
			if(!this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.LG)) {
				height = $(window).height();
			}
			else {
				height = $(window).width() * .66; // Ratio of 3:2
			}

			this.$carouselItems.each((index, item) => {
				let $padder = $(item).find(`.${CLS}-item-imgContainer-padder`);

				$padder.css({
					height: `${height}px`,
					paddingTop: 'unset'
				});
			});
		}
		else {
			this.$carouselItems.each((index, item) => {
				let $padder = $(item).find(`.${CLS}-item-imgContainer-padder`);
				$padder.css({
					height: `unset`,
					paddingTop: '70%' // was 66% and increased to 70$ as requested by client
				});
			});
		}

		// Slight delay as ratio is adjusting
		setTimeout(() => {
			this.$carouselItems.each((index, item) => {
				let $image = $(item).find(`.${CLS}-item-img`);
				let $imgContainer = $(item).find(`.${CLS}-item-imgContainer`);

				if($imgContainer.width() >= $imgContainer.height()) {
					$image.addClass(`${CLS}-item-img--horizontal`);
					$image.removeClass(`${CLS}-item-img--vertical`);

					if($imgContainer.height() > $image.height()) {
						$image.addClass(`${CLS}-item-img--vertical`);
						$image.removeClass(`${CLS}-item-img--horizontal`);
					}
				}
				else {
					$image.addClass(`${CLS}-item-img--vertical`);
					$image.removeClass(`${CLS}-item-img--horizontal`);

					if($imgContainer.width() > $image.width()) {
						$image.addClass(`${CLS}-item-img--horizontal`);
						$image.removeClass(`${CLS}-item-img--vertical`);
					}
				}
			});
		}, 50);
	}

	adjustArrowPosition() {
		let imgContainerHeight = this.$element.find(`.slick-active .${CLS}-item-imgContainer`).height();

		this.carouselArrowButton.each((_index, element) => {
			let $arrow = $(element);
			$arrow.css({
				top: `${((imgContainerHeight / 2) - ($arrow.height() / 2))}px`
			});
		});
	}

	adjustArrowVisibility() {
		if(this.selectedLayout !== this.layouts.FullScreen) {
			let $arrows = this.$element.find(`.slick-arrow`);
			if(!($arrows && $arrows.length > 0)) {
				return;
			}

			/*let previousArrow = this.$element.find(`.slick-arrow--previous`);
			let nextArrow = this.$element.find(`.slick-arrow--next`);

			previousArrow.css({
				visibility: Math.floor(previousArrow.offset().left) < 0 ? 'hidden' : 'visible'
			});

			nextArrow.css({
				visibility: (Math.ceil(nextArrow.offset().left + nextArrow.width()) + 1) >= this.getContainerWidth() ? 'hidden' : 'visible'
			});*/
		}
	}

	getContainerWidth() {
		let $tplContent = $('.tpl-content');
		if($tplContent && $tplContent.length > 0) {
			return $tplContent.width();
		}
		return $(window).width();
	}
}

Object.assign(CarouselBlock.prototype, trackingScrollMixinBlock);
Object.assign(CarouselBlock.prototype, fullWindowHeightMixinBlock);
